import { render, staticRenderFns } from "./DesignatedDoctorDropDownSelector.vue?vue&type=template&id=c33fdcc8&scoped=true&"
import script from "./DesignatedDoctorDropDownSelector.vue?vue&type=script&lang=ts&"
export * from "./DesignatedDoctorDropDownSelector.vue?vue&type=script&lang=ts&"
import style0 from "./DesignatedDoctorDropDownSelector.vue?vue&type=style&index=0&id=c33fdcc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33fdcc8",
  null
  
)

export default component.exports